import { Box, Button, Card, CardBody, CardFooter, CardHeader, FormField, Heading, Image, Layer, RadioButtonGroup } from "grommet"
import { useGetPaymentOptionsByUsernameQuery, useGetPaymentOptionsQuery } from "../../../api/paymentOptionsApi"
import { Close } from "grommet-icons";
import { useTranslation } from "react-i18next";

const paymentSelectors = {
    DONATELLO: {
        disabled: false,
        id: 'DONATELLO',
        label:  <Box><Image height={'25px'} width={'150px'} src={`${process.env.PUBLIC_URL}/images/donatello_300x50.png`} /></Box>,
        value: 'DONATELLO',
    },
    DONATIK: {
        disabled: false,
        id: 'DONATIK',
        label:  <Box><Image height={'25px'} width={'115px'} src={`${process.env.PUBLIC_URL}/images/donatik-logo.svg`} /></Box>,
        value: 'DONATIK',
    },
    MONOBANK: {
        disabled: false,
        id: 'MONOBANK',
        label:  <Box><Image height={'40px'} width={'40px'} src={`${process.env.PUBLIC_URL}/images/monobank-logo.png`} /></Box>,
        value: 'MONOBANK',
    }
}

export const PaymentOptionsSelector = ({ value, paymentOptions, onChange }) => {

    const { t } = useTranslation('donations', { useSuspense: false });

    return (
        <FormField name="paymentOption" label={t('paymentOptionsLabel')} >
            <RadioButtonGroup id="paymentOption" name="paymentOption" value={value} options={paymentOptions.map(paymentOption => paymentSelectors[paymentOption.type])} onChange={onChange} />
        </FormField>
    )
}